export type ServerStatus = 'online' | 'offline' | 'unknown';
export const serverRegions = ['jp', 'sg', 'us'] as const;
export type ServerRegion = (typeof serverRegions)[number];
export type ServerSort = 'name' | 'status' | 'lastReportedAt' | 'cpu' | 'memory';
export interface GatewayInstance {
  id: string;
  serverId: string;
  status: 'ready' | 'draining' | 'offline';
  desiredVersion: string;
  appliedVersion: string | null;
  inflightRequests: number | null;
  lastHeartbeatAt: string | null;
}
export interface GatewayServer {
  id: string;
  name: string;
  clusterId: string;
  region: ServerRegion;
  ip: string;
  status: ServerStatus;
  cpu: number | null;
  memory: number | null;
  disk: number | null;
  sampledAt: string | null;
  lastReportedAt: string | null;
  specification: string;
  instanceCount: number;
  readyCount: number;
}
export interface ServerDetails extends GatewayServer {
  instances: GatewayInstance[];
  registration?: ServerRegistration;
}
export interface ServerRegistration {
  id: string;
  state: 'pending' | 'registered' | 'expired';
  expiresAt: string;
  version: number;
  lastCheck: string | null;
  reason: string | null;
}
export interface CreateServerInput {
  name: string;
  region: ServerRegion;
  ip: string;
  specification?: string;
}
export const serverIpv4Pattern =
  /^(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/;
export interface ServerListInput {
  page: number;
  pageSize: number;
  q?: string;
  status?: ServerStatus;
  region?: ServerRegion;
  sort?: ServerSort;
  order?: 'asc' | 'desc';
}
